import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";
import { VCheckbox } from "vuetify/lib";

Vue.use(Vuetify, {
  Components: {
    VCheckbox
  }
});

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#391c6f",
        secondary: colors.red.lighten4, // #FFCDD2
        accent: colors.indigo.base, // #3F51B5
        background: "#f7f7f7"
      }
    }
  }
});
